// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9c6756e1","703":"359c4f8e","787":"f2e5eace"}[chunkId] + ".chunk.js";
};